import { useState, useEffect } from "react";
import axios from "axios";
import constraints from "../constraints";

const REDIRECT_URI = `${constraints.config.HOST_URL}/oauth/callback/kakao`;
const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${constraints.config.KAKAO_REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code`;

export default function Signin() {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);

  useEffect(() => {
    async function init() {
      const botId = new URL(window.location.href).searchParams.get("botId");
      const from = new URL(window.location.href).searchParams.get("from"); // CHANNEL, ETC ( 채널아닌 모든 경로 )
      const redirect = new URL(window.location.href).searchParams.get("redirect");

      if (redirect != null) {
        setRedirectUrl(`${constraints.config.HOST_URL}/oauth/callback/kakao?redirect=${redirect}`);
      } else {
        setRedirectUrl(`${constraints.config.HOST_URL}/oauth/callback/kakao?redirect=/oauth/complete`);
      }

      window.localStorage.setItem("from", from);

      if (botId != null) {
        window.localStorage.setItem("kakaoBotId", botId);

        const { data } = await axios.post("https://us-central1-art-generator-5a6dd.cloudfunctions.net/api/user/exists/kakaobot", {
          botId
        });

        if (data.isExist) {
          setIsLoading(false);
        } else {
          setIsError(true);
        }
      } else {
        setIsLoading(false);
      }
    }

    init();
  }, []);

  const onPressLogin = () => {
    window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${constraints.config.KAKAO_REST_API_KEY}&redirect_uri=${redirectUrl}&response_type=code`;
  };

  if (isError) {
    <div className="h-screen w-full flex flex-col justify-center items-center">
      <h1 className="text-2xl font-bold">400 ERROR</h1>
    </div>
  }

  if (!isLoading && !isError) {
    return (
      <div className="h-screen w-full flex flex-col justify-center items-center">
        <h1 className="text-2xl mb-10 font-serif">ART Gram 로그인</h1>

        <img src="/assets/gifs/home.gif" alt="home" className="w-1/2 mb-14" />
        <div onClick={onPressLogin} className="cursor-pointer">
          <img src="/assets/images/kakao_login_medium_wide.png" />
        </div>
      </div>
    );
  }

  if (isLoading) {
    <div className="h-screen w-full flex flex-col justify-center items-center">
      <h1 className="text-2xl font-bold">로그인 페이지 로딩중...</h1>
    </div>
  }
}